export default "__VITE_ASSET__CgfeYSW1__"